import React from 'react';
import 'react-mdl/extra/material.js';
import {Textfield, Icon} from 'react-mdl';
import moment from 'moment';
import SMAutoCompleteRow from 'components/search/SMAutoCompleteRow';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMClickOutsideObserver from 'lib/SMClickOutsideObserver';
import SMMapHelper from 'components/helpers/SMMapHelper';

// GooglePlacesAPI使用時のデフォルトパラメータ
// lat,lngは東京を指定
const GooglePlacesAPIDefault = {
  radius: 500000,
  types: ['geocode']
};

class SMSearchFormBaseView extends React.Component {

  constructor(props) {
    super(props);

    let priceType = props.priceType || '';
    if (props.eventType && props.eventType == 'stay') {
      priceType = 'stay';
    }

    this.state = {
      geocode: this.props.geocode || '',
      locationText: this.props.location || '',
      isStartDatepickerOpen: false,
      isEndDatepickerOpen: false,
      autoCompleteIsOpen: false,
      autoCompleteItems: [],
      autoCompleteSelectedRow : null,
      priceType: priceType,
      startedAt: this.props.startedAt || '',
      startedHour: this.props.startedHour || '',
      endedAt: this.props.endedAt || '',
      endedHour: this.props.endedHour || '',
      stayCheckinAt: this.props.stayCheckinAt,
      stayCheckoutAt: this.props.stayCheckoutAt,
      capacity: this.props.capacity || '',
      minCapacity: this.props.minCapacity || '',
      maxCapacity: this.props.maxCapacity || '',
      isPriceRangeOpen: false,
      isCapacityRangeOpen: false,
      isChangedLocationTextFromSomethingToBlank: false,
      datePickerTitle: '',
      hasDirectReservationPlans: this.props.hasDirectReservationPlans || '',
    };
  }

  componentDidMount() {

    this.autocomplete = new google.maps.places.AutocompleteService();

    setTimeout(()=>{
      this.initDatePicker();
      this.initPriceSlider();
      this.initCapacityRange();
    }, 1);
  }

  initDatePicker() {
    const defaultDate = moment.utc(this.state.startedAt).toDate();

    const $picker = $(this.refs.datePicker).datepicker({
      inline: true,
      minDate: 0,
      numberOfMonths: SMAppHelper.isMobile() ? 1 : 2,
      defaultDate: defaultDate,
      dateFormat:"yy/mm/dd",
      onSelect: (dateText)=>{

        const utc = moment.utc(dateText, 'YYYY/MM/DD');
        const date = utc.toDate();
        const value = utc.toISOString();

        if (this.state.isStartDatepickerOpen) {
          let state;
          const currentDay = moment(this.state.startedAt).utc().startOf('day').format();
          const pickedDay = moment(value).utc().startOf('day').format();
          if (currentDay == pickedDay) {
            state = {
              startedAt: '',
              stayCheckinAt: '',
              isStartDatepickerOpen: false,
            };
            if (this.state.priceType == 'hourly') {
               state['startedHour'] = '';
               state['endedHour'] = '';
            }
            $picker.datepicker('setDate', '');

          } else {
            state = {
              isStartDatepickerOpen: false,
              startedAt: value,
              startedHour: this.state.startedHour,
              endedHour: this.state.endedHour,
            };
            $picker.datepicker("option", "minDate", date);
          }

          this.setState(state);

          if (this.props.delegate && typeof this.props.delegate.changedDateAndHour === 'function') {
            this.props.delegate.changedDateAndHour(state.startedAt, this.state.endedAt, state.startedHour, state.endedHour);
          }
        }
        else if (this.state.isEndDatepickerOpen) {
          let state;
          if (this.state.endedAt == value) {
            state = {
              endedAt: '',
              stayCheckoutAt: '',
              isEndDatepickerOpen: false,
            };

          } else {
            state = {
              isEndDatepickerOpen: false,
            };
            state.endedAt = value;
            $picker.datepicker("option", "maxDate", date);
          }
          this.setState(state);

          if(this.props.delegate && typeof this.props.delegate.endedAtDidSelect === 'function'){
            this.props.delegate.endedAtDidSelect(state.endedAt);
          }
        }
      }
    });

    if (this.dateClickOutsideObserver) {
      this.dateClickOutsideObserver.detach();
    }
    this.dateClickOutsideObserver = new SMClickOutsideObserver(this.refs.datePickerContainer);
    this.dateClickOutsideObserver.attach(()=>{
      this.hideDatepicker();
    });
  }

  initPriceSlider() {

    $(this.refs.priceSlider).slider({
      range: true,
      min: 0,
      max: 100000,
      step: 5000,
      values: [0, 100000],
      slide: (event, ui)=>{
        this.props.delegate.minPriceRangeDidChange(ui.values[0]);
        this.props.delegate.maxPriceRangeDidChange(ui.values[1]);
      },
      stop: (event, ui)=>{
        this.props.delegate.priceRangeDidBlur('min_price', ui.values[0]);
      }
    });

    if (this.priceClickOutsideObserver) {
      this.priceClickOutsideObserver.detach();
    }
    this.priceClickOutsideObserver = new SMClickOutsideObserver(this.refs.priceSliderContainer);
    this.priceClickOutsideObserver.attach(()=>{
      this.setState({isPriceRangeOpen: false});
    });
  }

  initCapacityRange() {

    if (this.capacityClickOutsideObserver) {
      this.capacityClickOutsideObserver.detach();
    }
    this.capacityClickOutsideObserver = new SMClickOutsideObserver(this.refs.capacityRangeContainer);
    this.capacityClickOutsideObserver.attach(()=>{
      this.setState({isCapacityRangeOpen: false});
    });
  }

  capacityDidSelect(e) {
    const capacity = e.currentTarget.value;
    this.setState({
      capacity: capacity
    });
    if(this.props.delegate && typeof this.props.delegate.capacityDidSelect === 'function'){
      this.props.delegate.capacityDidSelect(capacity);
    }
  }

  priceTypeDidSelect(e) {
    const priceType = e.currentTarget.value;
    let state = {
      priceType: priceType,
      startedAt: this.state.startedAt,
      endedAt: this.state.endedAt,
    };

    if (priceType == 'hourly') {
      state['endedAt'] = null;
      state['endedAtText'] = null;
      // 開始、終了日をdaily検索で入れられている場合に選択範囲を解除する
      const $picker = $(this.refs.datePicker).datepicker();
      $picker.datepicker("option", "maxDate", '');
    } else {
      state['startedHour'] = null;
      state['endedHour'] = null;
    }
    this.setState(state);

    if(this.props.delegate && typeof this.props.delegate.priceTypeDidSelect === 'function'){
      this.props.delegate.priceTypeDidSelect(priceType, state.startedAt, state.endedAt);
    }
  }

  startedHourDidSelect(e) {
    const startedHour = e.currentTarget.value;
    let state = { startedHour: startedHour };
    let startedAt = this.state.startedAt;
    // 利用日が入っていない場合は明日の日付を入れる
    if (startedAt == null || startedAt == '') {
      startedAt = moment(new Date()).utc().startOf('day').add(1,'days').format();
      state['startedAt'] = startedAt;
      $(this.refs.datePicker).datepicker("setDate", moment.utc(startedAt).toDate());
    }
    this.setState(state);

    if (
      this.props.delegate &&
      typeof this.props.delegate.startedHourDidSelect === 'function'
    ) {
      this.props.delegate.startedHourDidSelect(startedAt, startedHour);
    }
  }

  endedHourDidSelect(e) {
    const endedHour = e.currentTarget.value;
    let state = { endedHour: endedHour };
    let startedAt = this.state.startedAt;
    // 利用日が入っていない場合は明日の日付を入れる
    if (startedAt == null || startedAt == '') {
      startedAt = moment(new Date()).utc().startOf('day').add(1,'days').format();
      state['startedAt'] = startedAt;
      $(this.refs.datePicker).datepicker("setDate", moment.utc(startedAt).toDate());
    }
    this.setState(state);

    if (
      this.props.delegate &&
      typeof this.props.delegate.endedHourDidSelect === 'function'
    ) {
      this.props.delegate.endedHourDidSelect(startedAt, endedHour);
    }
  }

  capacityRangeDidSelect(e) {
    this.setState({isCapacityRangeOpen: true});
  }

  priceRangeDidSelect(e) {
    this.setState({isPriceRangeOpen: true});
  }

  startedAtDidSelect(e) {
    const $picker = $(this.refs.datePicker).datepicker();
    $picker.datepicker("option", "minDate", 0);
    const label = this.getStartedAtFieldLabel(this.state.priceType);

    this.setState({
      isStartDatepickerOpen: !this.state.isStartDatepickerOpen,
      isEndDatepickerOpen: false,
      datePickerTitle: label,
    });
  }

  endedAtDidSelect(e) {
    const $picker = $(this.refs.datePicker).datepicker();
    $picker.datepicker("option", "maxDate", '');
    const label = this.getEndedAtFieldLable(this.state.priceType);

    this.setState({
      isEndDatepickerOpen: !this.state.isEndDatepickerOpen,
      isStartDatepickerOpen: false,
      datePickerTitle: label,
    });
  }

  clearUseDate() {
    this.setState({
      startedAt: '',
      endedAt: '',
      startedHour: '',
      endedHour: '',
    });

    // クリア時にカレンダーの選択範囲も消す
    const $picker = $(this.refs.datePicker).datepicker();
    $picker.datepicker("option", "minDate", 0);
    $picker.datepicker("option", "maxDate", '');

    if (this.props.delegate && typeof this.props.delegate.changedDateAndHour === 'function') {
      this.props.delegate.changedDateAndHour('', '', '', '');
    }
    this.hideDatepicker();
  }

  clearPriceRange() {
    this.setState({
      isPriceRangeOpen: false
    });

    if (this.props.delegate && typeof this.props.delegate.clearPriceRange === 'function') {
      this.props.delegate.clearPriceRange();
    }
  }

  clearCapacityRange() {
    this.setState({
      maxCapacity: '',
      minCapacity: '',
      isCapacityRangeOpen: false,
    });

    if (this.props.delegate && typeof this.props.delegate.clearCapacityRange === 'function') {
      this.props.delegate.clearCapacityRange();
    }
  }

  hideDatepicker() {
    this.setState({
      isStartDatepickerOpen: false,
      isEndDatepickerOpen: false,
    });
  }

  // SMAutoCompleteRow delegate
  autoCompleteDidHide() {
    this.setState({autoCompleteIsOpen: false});
  }

  autoCompleteDidChangeRow(row){
    this.setState({autoCompleteSelectedRow: row});
  }

  locationDidStartEditing(e) {
  }

  locationDidEndEditing(e) {
    // エリア指定からフォーカスアウト時にテキストに何か値入った状態から空になれば再検索
    const query = e.currentTarget.value;
    if (!query) {
      if (this.state.isChangedLocationTextFromSomethingToBlank) {
        const state = {
          isChangedLocationTextFromSomethingToBlank: false,
        };
        this.setState(state);

        if (this.props.delegate && typeof this.props.delegate.locationDidSelect === 'function') {
          this.props.delegate.locationDidSelect(state.geocode, state.locationText);
        }
      }
    }
  }

  locationDidChangeValue(e) {
    const query = e.currentTarget.value;
    if (!query) {
      let isChangedLocationTextFromSomethingToBlank = false;
      if (this.state.locationText != "" && this.state.locationText != null) {
        isChangedLocationTextFromSomethingToBlank = true;
      }
      const state = {
        location: '',
        locationText: '',
        geocode: '',
        autoCompleteItems: [],
        autoCompleteIsOpen: false,
        isChangedLocationTextFromSomethingToBlank: isChangedLocationTextFromSomethingToBlank,
      };
      this.setState(state);
      $(this.refs.locationField).blur();

      return;
    }
    this.setState({
      locationText: query,
    });
    this.autocomplete.getPlacePredictions({
      input: query, types: GooglePlacesAPIDefault.types, location: SMMapHelper.defaultPosition(), radius: GooglePlacesAPIDefault.radius}, (predictions, status) => {
      if (status == google.maps.places.PlacesServiceStatus.OK) {
        let autoCompleteItems = [];
        predictions = SMMapHelper.sortPredictions(predictions);
        predictions.forEach(function(prediction) {
          autoCompleteItems.push(prediction);
        });
        this.setState({
          autoCompleteItems: autoCompleteItems,
          autoCompleteIsOpen: true,
        });
      } else {
        this.setState({
          autoCompleteItems: [],
          autoCompleteIsOpen: false,
        });
      }
    });
  }

  autoCompleteItemDidSelect(i){
    const item = this.state.autoCompleteItems[i];
    const googlePlacesService = new google.maps.places.PlacesService(this.refs.locationField.inputRef);
    googlePlacesService.getDetails({placeId:item.place_id}, (details, status)=>{
      const displayText = item.terms[0].value;
      let state = {
        autoCompleteIsOpen: false,
      };
      if (details) {
        const l = details.geometry.location;
        const vp = details.geometry.viewport;
        const radius = SMMapHelper.getRadiusByViewport(vp);
        state['geocode'] = SMMapHelper.getGeocode(l.lat(), l.lng(), radius);
        state['locationText'] = displayText;
      }
      this.setState(state);
      $(this.refs.locationField).blur();

      if(this.props.delegate && typeof this.props.delegate.locationDidSelect === 'function'){
        this.props.delegate.locationDidSelect(state.geocode, state.locationText);
      }
    });
  }

  directReservationDidSelect(e){
    const value = !this.state.hasDirectReservationPlans || '';
    this.setState({
      hasDirectReservationPlans: value
    });

    if(this.props.delegate && typeof this.props.delegate.priceTypeDidSelect === 'function'){
      this.props.delegate.directReservationDidSelect(value);
    }
  }

  formatStartedAtText() {
    const dateFormat = 'M月D日';
    if (this.state.startedAt) {
      return moment(this.state.startedAt).utc().format(dateFormat);
    }
    return '';
  }

  formatHourText(hour) {
    // 36時間まで表示するため独自にフォーマットを整形する
    if (hour != null && hour != '') {
      return hour + ":00";
    }
    return '';
  }

  formatEndedAtText() {
    const dateFormat = 'M月D日';
    if (this.state.endedAt) {
      return moment(this.state.endedAt).utc().format(dateFormat);
    }
    return '';
  }

  formatPriceRangeText() {
    const min = this.props.minPrice;
    const max = this.props.maxPrice;
    if (min && max) return(`${min}円〜${max}円`);
    else if (min) return `${min}円〜`;
    else if (max) return `〜${max}円`;
    return '';
  }

  formatCapacityRangeText() {
    const min = this.state.minCapacity;
    const max = this.state.maxCapacity;
    if (min && max) return(`${min}人〜${max}人`);
    else if (min) return `${min}人〜`;
    else if (max) return `〜${max}人`;
    return '';
  }

  renderCapacitySelect(className) {
    return (
      <div className={className}>
        <div className="mdl-textfield mdl-textfield--floating-label is-focused w100pa">
          <label className="mdl-textfield__label">{I18n.t('service.label_000076')}</label>
          <span className="service-select material-select">
            <select
              name="capacity"
              value={this.state.capacity}
              onChange={this.capacityDidSelect.bind(this)}
              className="w100pa">
              {(()=>{
                let options = [
                  <option key="none" value="">{I18n.t('service.label_000047')}</option>,
                  <option key="0" value="1">{I18n.t('service.label_000104')}</option>
                ];
                this.props.capacityList.forEach((capacity)=>{
                  options.push(
                    <option key={capacity.id} value={capacity.name}>{capacity.name_text}</option>
                  );
                });
                return options;
              })()}
            </select>
          </span>
        </div>
      </div>
    );
  }

  renderDatePicker(className) {
    const style = {display: (this.state.isStartDatepickerOpen || this.state.isEndDatepickerOpen ? 'block' : 'none')};
    let title = this.state.datePickerTitle;
    if (!title) {
      title = "利用日";
    }
    return (
      <div className={className} style={style}>
        <div className="date-select-layout__inner">
          <div ref="datePickerContainer" className="datetime-layout__inner-day">
            <h2 className="search-change__main-title fl search-change__main-title_date">{title}</h2>
            <p><a href="#" onClick={this.clearUseDate.bind(this)} className="search-change__main-clear">クリア</a></p>
            <div className="clear">
              <div ref="datePicker"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderPriceRange(className) {
    return (
      <div className={className}>
        <Textfield
          className="w100pa service-input-icn"
          onClick={this.priceRangeDidSelect.bind(this)}
          value={this.formatPriceRangeText()}
          inputClassName="top-search__box-list-input"
          floatingLabel={true}
          readOnly={true}
          label={'価格帯'} />
        {(()=>{
          return (
            <div ref="priceSliderContainer" style={{display: this.state.isPriceRangeOpen ? 'block' : 'none'}} className="search-slider-layout">
              <div className="search-slider-layout__inner">
                <div className="search-slider__area js-slider__horizontal">
                  <h2 className="search-change__main-title fl">価格帯</h2>
                  <p><a href="#" onClick={this.clearPriceRange.bind(this)} className="search-change__main-clear">クリア</a></p>
                  <div className="clear">
                    <div id="js-slider__range" ref="priceSlider"></div>
                    <div className="search-slider__pricebox clearfix">
                      <div className="fl">
                        <input
                          name="min_price"
                          placeholder="0"
                          onBlur={this.priceRangeDidBlur.bind(this)}
                          onChange={this.minPriceRangeDidChange.bind(this)}
                          type="number"
                          value={this.props.minPrice}
                          className="search-slider__input" />
                        <span className="search-slider__price">円〜</span>
                      </div>
                      <div className="fr">
                        <input
                          name="max_price"
                          placeholder="100000"
                          onBlur={this.priceRangeDidBlur.bind(this)}
                          onChange={this.maxPriceRangeDidChange.bind(this)}
                          type="number"
                          value={this.props.maxPrice}
                          className="search-slider__input" />
                        <span className="search-slider__price">円</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })()}
      </div>
    );
  }

  renderCapacityRange(className) {
    return (
      <div className={className}>
        <Textfield
          className="w100pa service-input-icn"
          onClick={this.capacityRangeDidSelect.bind(this)}
          value={this.formatCapacityRangeText()}
          inputClassName="top-search__box-list-input"
          floatingLabel={true}
          readOnly={true}
          label={'人数'} />
        {(()=>{
          return (
            <div style={{display: this.state.isCapacityRangeOpen ? 'block' : 'none'}} className="person-num-layout">
              <div className="person-num-layout__inner" ref="capacityRangeContainer">
                <div className="person-num__area js-slider__horizontal">
                  <h2 className="person-num__main-title fl">人数</h2>
                  <p><a href="#" onClick={this.clearCapacityRange.bind(this)} className="search-change__main-clear">クリア</a></p>
                    <div className="row clear">
                      <div className="col-xs-5">
                        <div className="mdl-textfield w100pa">
                          <span className="service-select material-select">
                            <select name="min_capacity" className="w100pa"
                              value={this.state.minCapacity}
                              onChange={this.minCapacityRangeDidChange.bind(this)}>
                              {(()=>{
                                let options = [
                                  <option key="0" value="1">1人</option>
                                ];
                                this.props.capacityList.forEach((capacity)=>{
                                  options.push(
                                    <option key={capacity.id} value={capacity.name}>{capacity.name}人</option>
                                  );
                                });
                                return options;
                              })()}
                            </select>
                          </span>
                        </div>
                      </div>
                      <div className="col-xs-2">
                        <span className="search-box__while-txt">〜</span>
                      </div>
                      <div className="col-xs-5">
                        <div className="mdl-textfield w100pa">
                          <span className="service-select material-select">
                            <select name="max_capacity" className="w100pa"
                              value={this.state.maxCapacity}
                              onChange={this.maxCapacityRangeDidChange.bind(this)}>
                              {(()=>{
                                let options = [
                                  <option key="none" value="">{I18n.t('service.label_000047')}</option>,
                                ];
                                this.props.capacityList.forEach((capacity)=>{
                                  options.push(
                                    <option key={capacity.id} value={capacity.name}>{capacity.name}人</option>
                                  );
                                });
                                return options;
                              })()}
                            </select>
                          </span>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          );
        })()}
      </div>
    );
  }

  minPriceRangeDidChange(e) {
    if(this.props.delegate && typeof this.props.delegate.minPriceRangeDidChange === 'function'){
      this.props.delegate.minPriceRangeDidChange(e.currentTarget.value);
    }
  }

  maxPriceRangeDidChange(e) {
    if(this.props.delegate && typeof this.props.delegate.maxPriceRangeDidChange === 'function'){
      this.props.delegate.maxPriceRangeDidChange(e.currentTarget.value);
    }
  }

  priceRangeDidBlur(e) {
    if(this.props.delegate && typeof this.props.delegate.priceRangeDidBlur === 'function'){
      this.props.delegate.priceRangeDidBlur(e.currentTarget.name, e.currentTarget.value);
    }
  }

  minCapacityRangeDidChange(e) {
    const capacity = e.currentTarget.value;
    this.setState({minCapacity: capacity});
    if (this.state.maxCapacity) this.setState({isCapacityRangeOpen: false});

    if(this.props.delegate && typeof this.props.delegate.minCapacityRangeDidChange === 'function'){
      this.props.delegate.minCapacityRangeDidChange(e.currentTarget.value);
    }
  }

  maxCapacityRangeDidChange(e) {
    const capacity = e.currentTarget.value;
    this.setState({maxCapacity: capacity});
    if (this.state.minCapacity) this.setState({isCapacityRangeOpen: false});

    if(this.props.delegate && typeof this.props.delegate.maxCapacityRangeDidChange === 'function'){
      this.props.delegate.maxCapacityRangeDidChange(e.currentTarget.value);
    }
  }

  renderPriceTypeSelect(className) {
    if (this.props.eventType == 'stay') return null;
    return (
      <div className={className}>
        <div className="w100pa select__price-type">
          <div className="mdl-textfield mdl-js-textfield w100pa service-input-icn">
            <input
              className="mdl-textfield__input"
              type="text"
            />
            <label className="mdl-textfield__label fa">
              {(()=>{
                switch (this.state.priceType) {
                  case 'hourly':
                    return (<Icon name="access_time" />);
                case 'daily':
                  return (<i className="fa-calendar" />);
                default:
                  return (<i className="fa-minus" />);
              }
            })()}
            </label>

            <select className="w100pa js-select__transparent"
              name="price_type"
              value={this.state.priceType}
              onChange={this.priceTypeDidSelect.bind(this)}>
              <option value="hourly,daily">指定なし</option>
              <option value="hourly">時間単位で予約</option>
              <option value="daily">1日単位で予約</option>
            </select>
          </div>
        </div>
      </div>
    );
  }

  renderAreaField(className, name) {
    name = name || 'location';
    return (
      <div className={className}>
        <input key="geocode" type="hidden" name="geocode" value={this.state.geocode} />
        <Textfield
          ref="locationField"
          name={name}
          value={this.state.locationText}
          className="service-input-icn"
          maxLength="2048"
          aria-haspopup="false"
          aria-autocomplete="both"
          spellCheck="false"
          autoComplete="off"
          onFocus={this.locationDidStartEditing.bind(this)}
          onBlur={this.locationDidEndEditing.bind(this)}
          onChange={this.locationDidChangeValue.bind(this)}
          floatingLabel={true}
          label="エリア" />
        <SMAutoCompleteRow
          isOpen={this.state.autoCompleteIsOpen}
          items={this.state.autoCompleteItems}
          selectedRow={this.state.autoCompleteSelectedRow}
          isTop={true}
          delegate={this}
           />
      </div>
    );
  }

  renderStartedAtField(className) {
    const priceType = this.state.priceType;
    const label = this.getStartedAtFieldLabel(this.state.priceType);

    return (
      <div className={className}>
        {(()=>{
          return (
            <input type="hidden" name="started_at" value={this.state.startedAt} />
          );
        })()}
        <Textfield
          className="w100pa service-input-icn"
          onClick={this.startedAtDidSelect.bind(this)}
          value={this.formatStartedAtText()}
          inputClassName="top-search__box-list-input"
          floatingLabel={true}
          readOnly={true}
          label={label} />
      </div>
    );
  }

  getStartedAtFieldLabel(priceType) {
    let label = '開始';
    switch (priceType) {
      case 'hourly': label = '利用日'; break;
      case 'stay': label = 'チェックイン'; break;
      default:
    }
    return label;
  }

  renderStartedHourField(className) {
    const priceType = this.state.priceType;
    if (priceType != 'hourly') return null;
    const label = '開始';

    return (
      <div className={className}>
        <Textfield
          className="w100pa service-input-icn"
          value={this.formatHourText(this.state.startedHour)}
          inputClassName="top-search__box-list-input"
          floatingLabel={true}
          readOnly={true}
          label={label} />

        <select className="w100pa js-select__transparent"
          name="start_hour"
          value={this.state.startedHour}
          onChange={this.startedHourDidSelect.bind(this)}>
          { this.renderHourItems(0,23) }
        </select>
      </div>
    );
  }

  renderEndedHourField(className) {
    const priceType = this.state.priceType;
    if (priceType != 'hourly') return null;
    const label = '終了';

    return (
      <div className={className}>
        <Textfield
          className="w100pa service-input-icn"
          value={this.formatHourText(this.state.endedHour)}
          inputClassName="top-search__box-list-input"
          floatingLabel={true}
          readOnly={true}
          label={label} />

        <select className="w100pa js-select__transparent"
          name="end_hour"
          value={this.state.endedHour}
          onChange={this.endedHourDidSelect.bind(this)}>
          { this.renderHourItems(1,36) }
        </select>
      </div>
    );
  }

  renderHourItems(startHour, endHour) {
    let rows = [];
    rows.push(<option value="">指定なし</option>);
    for (let i = startHour; i <= endHour; i++) {
      rows.push(<option value={i}>{i}:00</option>);
    }
    return rows;
  }

  renderEndedAtField(className) {
    const priceType = this.state.priceType;
    if (priceType == 'hourly') return null;
    let label = this.getEndedAtFieldLable(this.state.priceType);

    return (
      <div className={className}>
        {(()=>{
          return (
            <input type="hidden" name="ended_at" value={this.state.endedAt} />
          );
        })()}
        <Textfield
          className="w100pa service-input-icn"
          onClick={this.endedAtDidSelect.bind(this)}
          value={this.formatEndedAtText()}
          inputClassName="top-search__box-list-input"
          floatingLabel={true}
          readOnly={true}
          label={label} />
      </div>
    );
  }

  getEndedAtFieldLable(priceType) {
    let label = '終了';
    switch (priceType) {
      case 'hourly': label = ''; break;
      case 'stay': label = 'チェックアウト'; break;
      default:
    }
    return label;
  }

  renderDirectReservationCheckbox(className) {
    return(
      <div className={className}>
        <div className="mt15">
          <input type="checkbox" value={true} id="has_direct_reservation_plans" name="has_direct_reservation_plans" checked={this.state.hasDirectReservationPlans == true} onChange={this.directReservationDidSelect.bind(this)} />
          <label htmlFor="has_direct_reservation_plans" className="form-checkbox__s">
            <i className="fa fa-flash search-change__direct-icon"></i>今すぐ予約可
          </label>
        </div>
      </div>
    );
  }

  renderFilterButton() {
    const badge = this.props.filterCount > 0 ? this.props.filterCount : '';
    return (
      <div className="col-xs-12 col-md-1 search-filter__btn sm-hide">
        <div className="search-filter__btn-inner">
          <a href="#" onClick={this.toggleFilter.bind(this)} className="search-filter__btn-item">
            <span className="search-filter__btn-txt-wrap">
              <i className="fa fa-sliders search-filter__icon"></i>
              <span className="search-filter__btn-txt">詳細検索</span>
            </span>
            {(()=>{
              if (badge) return <span className="search-filter__number">{badge}</span>;
            })()}
          </a>
        </div>
      </div>
    );
  }

}
export default SMSearchFormBaseView;



// WEBPACK FOOTER //
// ./app/javascript/components/search/SMSearchFormBaseView.jsx